/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import { IDefaInfoTileData } from './defa-info-tile.data';
import { IDefaInfoTileProps } from './defa-info-tile.props.autogenerated';

export interface IDefaInfoTileViewProps extends IDefaInfoTileProps<IDefaInfoTileData> {
    baseClassName: string;
    infoTile: IModuleProps;
    title: JSX.Element | null;
    text: JSX.Element | null;
}

/**
 *
 * DefaInfoTile component
 * @extends {React.PureComponent<IDefaInfoTileProps<IDefaInfoTileData>>}
 */
class DefaInfoTile extends React.PureComponent<IDefaInfoTileProps<IDefaInfoTileData>> {

    private readonly baseClassName: string = 'defa-info-tile';

    public render(): JSX.Element | null {
        const viewProps: IDefaInfoTileViewProps = {
            ...this.props,
            baseClassName: this.baseClassName,
            infoTile: {
                className: this.baseClassName,
                moduleProps: this.props
            },
            title: this._renderTitle(),
            text: this._renderText()
        };
        return this.props.renderView(viewProps);
    }

    private _renderTitle(): JSX.Element | null {
        return (
            <div className={`${this.baseClassName}__title`}>{this.props.config.title}</div>
        );
    }

    private _renderText(): JSX.Element | null {
        return (
            <div className={`${this.baseClassName}__text`}>{this.props.config.text}</div>
        );
    }
}

export default DefaInfoTile;
